module.exports = __webpack_public_path__ + "img/scanCode.2ac9f52e.png";